export class PopoverTitleStyle {
  size = '';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  color = '';
  marginTop = 'uk-margin-remove-top';
  cursor = '';

  static normalize(styles: Partial<PopoverTitleStyle>): PopoverTitleStyle {
    const pureStyles = new PopoverTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.cursor = styles.cursor ?? pureStyles.cursor;

    return pureStyles;
  }
}
